<!-- NAV NEW -->
<app-cruise-information-tabs [boatInfo]="boatInfo" *ngIf="detailInfoTemplate == 'tabs'"
    [option]="this.cruiseServiceAux.getOption()"></app-cruise-information-tabs>
<!-- NAV OLD -->
<app-cruise-information-accordion [boatInfo]="boatInfo"
    *ngIf="detailInfoTemplateNotDefined || detailInfoTemplate == 'accordion'"
    [option]="this.cruiseServiceAux.getOption()"></app-cruise-information-accordion>